/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

export const mapBedrooms = (bedrooms: readonly boolean[]) => {
  const mapped: number[] = []
  for (let i = 0; i < bedrooms.length; i++) {
    if (bedrooms[i]) {
      mapped.push(i)
    }
  }
  return mapped
}
